var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoPersonalUse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Info",
    clipPath: "url(#clip0_13742_95980)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M26.8125 23.1963L26.8125 34.5713",
    stroke: "#CC0000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M26.8125 18.3213C27.71 18.3213 28.4375 17.5938 28.4375 16.6963C28.4375 15.7988 27.71 15.0713 26.8125 15.0713C25.915 15.0713 25.1875 15.7988 25.1875 16.6963C25.1875 17.5938 25.915 18.3213 26.8125 18.3213Z",
    fill: "#CC0000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M26.8125 45.5C37.5821 45.5 46.3125 36.7696 46.3125 26C46.3125 15.2304 37.5821 6.5 26.8125 6.5C16.0429 6.5 7.3125 15.2304 7.3125 26C7.3125 36.7696 16.0429 45.5 26.8125 45.5Z",
    stroke: "#CC0000",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13742_95980"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoPersonalUse);
export default __webpack_public_path__ + "static/media/Info-Personal-Use.c090eeff44f1be1aad071081a66b1632.svg";
export { ForwardRef as ReactComponent };